import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "form-input",
  ref: "containerRef"
}
const _hoisted_2 = { class: "wrapper-label" }
const _hoisted_3 = { class: "selected-option" }
const _hoisted_4 = { class: "select-options" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", {
        class: _normalizeClass(["label-input", { 'label-disabled': _ctx.isDisabled }])
      }, _toDisplayString(_ctx.label), 3)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["custom-select", { disabled: _ctx.isDisabled }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
    }, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.selectedLabel || (_ctx.isDisabled ? "Deshabilitado" : _ctx.placeholderText)), 1),
      _createElementVNode("img", {
        class: _normalizeClass(["select-arrow", { rotated: _ctx.isOpen }]),
        src: "assets/administrator/DownArrow.svg",
        alt: "arrow"
      }, null, 2),
      _withDirectives(_createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: "option-item",
            onClick: _withModifiers(($event: any) => (_ctx.selectOption(option)), ["stop"])
          }, _toDisplayString(option.value), 9, _hoisted_5))
        }), 128))
      ], 512), [
        [_vShow, _ctx.isOpen && _ctx.options?.length]
      ])
    ], 2),
    _createElementVNode("p", {
      class: _normalizeClass(_ctx.hasError ? 'error' : 'no-error')
    }, _toDisplayString(_ctx.hasError ? _ctx.error.esMessage : ""), 3)
  ], 512))
}